import { _ as _extends } from "../extends-e61fd370.js";
import { _ as _objectWithoutProperties } from "../objectWithoutProperties-72d23964.js";
import React__default from 'react';
import PropTypes from 'prop-types';
var _excluded = ["children"];

function Cards(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "flex flex-wrap -mx-2"
  }, props), React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "w-1/3 px-2 mb-4",
      key: child
    }, child);
  }));
}

Cards.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export { Cards as default };